import { get } from 'lodash';
import { RegionType } from '@wix/shoutout-email-model-v3';
import { injectMissingPropsIntoHtml } from '../../utils/inject-missing-props-into-html';
import { wrapWithElement } from '../../utils/wrap-with-element';
import { defaultLineHeight, defaultTextColor, defaultTextSize, } from '../../utils/defaults';
import { getRegionMobileCssClass, prop, textAlign, margin as getMargin, padding as getPadding, } from '../../utils/css-utils';
export var getTextSection = function (_a) {
    var composerData = _a.composerData, css = _a.css, experiments = _a.experiments, region = _a.region, isRtl = _a.isRtl, manipulateHtml = _a.manipulateHtml;
    if (region.type !== RegionType.Text) {
        throw Error('Text must be passed');
    }
    var isTitle = region.fixed;
    var userOverrides = get(region, 'data.styles.region', {});
    var rules = isTitle
        ? [
            userOverrides,
            css['so-global-title'],
            css['so-global-region-title'],
            css['so-global-region'],
        ]
        : [
            userOverrides,
            css['so-global-p1'],
            css['so-global-text'],
            css['so-global-region-text'],
            css['so-global-region'],
        ];
    var cssClass = isTitle ? 'so-global-title' : 'so-global-p1';
    var html = manipulateHtml
        ? injectMissingPropsIntoHtml(wrapWithElement(region.data.html, 'div', cssClass), {
            lineHeight: defaultLineHeight,
            fontSize: prop('fontSize')(rules) || defaultTextSize,
        }, composerData, css, experiments, true)
        : wrapWithElement(region.data.html, 'div', cssClass);
    var borderWidth = prop('borderWidth')(rules) || 0;
    var borderStyle = prop('borderStyle')(rules) || 'none';
    var borderColor = prop('borderColor')(rules) || 'transparent';
    var text = {
        backgroundColor: prop('backgroundColor')(rules) || 'transparent',
        border: borderWidth + " " + borderStyle + " " + borderColor,
        borderRadius: prop('borderRadius')(rules) || 0,
    };
    return {
        cssClass: cssClass + " " + getRegionMobileCssClass(rules, true),
        html: html,
        fonts: region.data.fonts,
        align: textAlign(isRtl)(rules),
        color: prop('color')(rules) || defaultTextColor,
        fontFamily: prop('fontFamily')(rules),
        fontSize: prop('fontSize')(rules) || defaultTextSize,
        fontStyle: prop('fontStyle')(rules) || 'normal',
        textTransform: prop('textTransform')(rules) || 'none',
        outerPadding: getMargin(rules),
        innerPadding: getPadding(rules),
        textBackground: text,
    };
};
//# sourceMappingURL=get-text-section.js.map